import {Component, Input, OnInit} from '@angular/core';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import {PreviewModalService} from '@services/preview-modal.service';
import {EquipmentDataFlowService} from '@modules/equipment-view/services/equipment-data-flow.service';

@Component({
    selector: 'app-equipment-view-tab-repairs',
    templateUrl: 'equipment-view-tab-repairs.component.html'
})

export class EquipmentViewTabRepairsComponent implements OnInit {

    @Input() repairs: EquipmentCardInterfaces.EquipmentRepairViewData[] = [];

    constructor(
        private dataService: EquipmentDataFlowService,
        private filesPreviewService: PreviewModalService,
    ) {
    }

    ngOnInit() {
    }

    addRepair() {
        this.dataService.addRepair$.next();
    }

    showFilesPreview(repair: EquipmentCardInterfaces.EquipmentRepairViewData) {
        this.filesPreviewService.show({
            files: repair.files,
            title: 'Копии ведомостей, актов ремонта',
        });
    }
}
